import React, { Fragment, useState } from "react"
import PropTypes from "prop-types"
import _map from "lodash/map"
import _capitalize from "lodash/capitalize"
import _isEmpty from "lodash/isEmpty"
import classnames from "classnames"

import DefaultContainer from "shared/components/DefaultContainer"
import Typograph from "../../../../components/Typograph"
import Table from "../../../../components/Table"
import TableRow from "../../../../components/Table/components/TableRow"
import TableHeader from "../../../../components/Table/components/TableHeader"
import TableCell from "../../../../components/Table/components/TableCell"
import Bullets from "shared/components/Bullets"
import WrapperSkeleton from "../../../../components/WrapperSkeleton"
import EmptyState from "shared/components/EmptyState"
import ModalAutoServices from "../../../../components/ModalAutoServices"
import AutoServicesButton from "../../../../components/AutoServicesButton"
import ProtocolDetailsModal from "../ProtocolDetailsModal"

import styles from "./styles.css"

import {
  normalizeProtocolDetails,
  formatStatusText,
  formatStatusType
} from "../../helpers"

import arrowButton from "assets/svg/button-green.svg"
import emptyStateIcon from "assets/svg/icon-ok.svg"

const History = ({ t, historyData, productServiceRequest, loading }) => {
  const [isOpenHistoryModal, setIsOpenHistoryModal] = useState(false)
  const [isOpenDetailsModal, setIsOpenDetailsModal] = useState(false)
  const [protocolDetails, setProtocolDetails] = useState({})
  const [generalProtocolDetails, setGeneralProtocolDetails] = useState({
    details: [],
    phoneDetails: []
  })

  const defaultContainerClass = classnames({
    [styles.defaultContainerClass]: historyData.length > 4
  })

  const scrollTableClass = classnames({
    [styles.scrollTableClass]: historyData.length > 4
  })

  const handleOpenHistoryModal = (item) => {
    setIsOpenHistoryModal(true)
    setProtocolDetails(item)
  }
  const handleCloseHistoryModal = (item) => {
    setIsOpenHistoryModal(false)
    setProtocolDetails({})
  }
  const handleOpenDetailsModal = () => {
    setIsOpenDetailsModal(true)
    setIsOpenHistoryModal(false)
    const formatDetails = normalizeProtocolDetails(
      protocolDetails,
      productServiceRequest
    )

    setGeneralProtocolDetails({
      details: formatDetails.details,
      phoneDetails: formatDetails.phoneDetails
    })
  }
  const handleCloseDetailsModal = () => {
    setIsOpenDetailsModal(false)
    setGeneralProtocolDetails({})
  }

  return (
    <Fragment>
      <WrapperSkeleton path="historyOnlineInterface" isChildrenReady={!loading}>
        {_isEmpty(historyData) && (
          <EmptyState
            icon={emptyStateIcon}
            title="Histórico"
            description={t("EMPTY_HISTORIC")}
          />
        )}

        {!_isEmpty(historyData) && (
          <DefaultContainer customClass={defaultContainerClass}>
            <Typograph
              htmlTag="h2"
              size="medium"
              color="outer_space"
              weight="bold"
            >
              {t("HISTORIC")}
            </Typograph>
            <div className={styles.mainTableClass}>
              <div className={scrollTableClass}>
                <Table>
                  <thead>
                    <TableRow>
                      <TableHeader>Protocolo</TableHeader>
                      <TableHeader>DDG</TableHeader>
                      <TableHeader>Tipo de solicitação</TableHeader>
                      <TableHeader>Status</TableHeader>
                    </TableRow>
                  </thead>

                  <tbody>
                    {_map(historyData, (item, index) => (
                      <TableRow key={index}>
                        <TableCell>{item.protocol}</TableCell>
                        <TableCell>
                          {_capitalize(item.productLine.name)}
                        </TableCell>
                        <TableCell>
                          {_map(item.fields, (field) =>
                            _capitalize(field.stringFieldValue)
                          )}
                        </TableCell>
                        <TableCell>
                          {_map(item.fields, (field) => (
                            <Bullets
                              text={formatStatusText(field)}
                              type={formatStatusType(field)}
                            />
                          ))}
                        </TableCell>
                        <TableCell className={styles.buttonCellClass}>
                          <button onClick={() => handleOpenHistoryModal(item)}>
                            <img src={arrowButton} />
                          </button>
                          <ModalAutoServices
                            positionModalClass={styles.positionModalClass}
                            isOpenModal={
                              isOpenHistoryModal &&
                              item.id === protocolDetails.id
                            }
                            closeModal={handleCloseHistoryModal}
                          >
                            <AutoServicesButton
                              onClick={handleOpenDetailsModal}
                            >
                              Ver mais detalhes
                            </AutoServicesButton>
                          </ModalAutoServices>
                        </TableCell>
                      </TableRow>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </DefaultContainer>
        )}
      </WrapperSkeleton>

      <ProtocolDetailsModal
        isOpen={isOpenDetailsModal}
        onClose={handleCloseDetailsModal}
        generalProtocolDetails={generalProtocolDetails}
        protocolDetails={protocolDetails}
        t={t}
      />
    </Fragment>
  )
}

History.propTypes = {
  t: PropTypes.func,
  historyData: PropTypes.array,
  productServiceRequest: PropTypes.array,
  loading: PropTypes.boolean
}
export default History



// WEBPACK FOOTER //
// ./src/scenes/NewInterfaceOnline/components/History/index.js